import { ReservationResponse } from '@myrealtrip/messenger-core';

export const StatusKeyType = {
  ASK: 'ASK',
  NONE: 'NONE',
  RESERVATION_CANCEL: 'RESERVATION_CANCEL',
  RESERVATION_CONFIRM: 'RESERVATION_CONFIRM',
  RESERVATION_FINISH: 'RESERVATION_FINISH',
  RESERVATION_WAIT_CONFIRM: 'RESERVATION_WAIT_CONFIRM',
} as const;

export interface ProductInfo {
  productTitle: string;
  productImageUrl: string;
  productLink: string;
  reservationLink: string;
  latestReservation: ReservationResponse | null;
}
